var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovieDownloadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.73,
    height: 18.73,
    viewBox: "0 0 18.73 18.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sync_FILL0_wght400_GRAD0_opsz48",
    d: "M21.287,25.823a.772.772,0,0,1-.819,0,.966.966,0,0,1-.2-1.258.939.939,0,0,1,.38-.351,7.19,7.19,0,0,0,3.175-2.824,7.727,7.727,0,0,0,1.156-4.112,6.618,6.618,0,0,0-.688-2.853,9.127,9.127,0,0,0-1.8-2.561l-.849-.761v2.751a.878.878,0,1,1-1.756,0V8.878A.851.851,0,0,1,20.76,8h4.975a.878.878,0,1,1,0,1.756H22.78l.439.41a11.521,11.521,0,0,1,2.634,3.512,8.473,8.473,0,0,1,.878,3.6,9.171,9.171,0,0,1-1.478,5.092A9.394,9.394,0,0,1,21.287,25.823Zm-12.2.907a.878.878,0,1,1,0-1.756h2.927l-.439-.351a9.5,9.5,0,0,1-2.722-3.249A8.894,8.894,0,0,1,8,17.453a9.111,9.111,0,0,1,1.507-5.107A9.355,9.355,0,0,1,13.5,8.907a.761.761,0,0,1,.8.044.9.9,0,0,1,.337.776.807.807,0,0,1-.146.454.973.973,0,0,1-.38.337,7.4,7.4,0,0,0-3.175,2.824,7.585,7.585,0,0,0-1.185,4.112,7.022,7.022,0,0,0,.688,3.2A7.509,7.509,0,0,0,12.3,23.014l.878.615V20.877a.878.878,0,1,1,1.756,0v4.975a.851.851,0,0,1-.878.878Z",
    transform: "translate(-8 -8)",
    fill: "#62b0dc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieDownloadingIcon);
export default __webpack_public_path__ + "static/media/MovieDownloadingIcon.50d6971514e9c679beb6e1ae65a6ccbc.svg";
export { ForwardRef as ReactComponent };